module.exports = __webpack_public_path__ + "assets/img/img78.2100b23f.png";